// Path: ./src/app/pages/CreateDealTab/index.tsx
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { CircularProgress, Grid } from "@mui/material";
import { CheckBoxMui } from "../../components/CheckBox";
import CancelIcon from "@mui/icons-material/Cancel";
import { useContext, useEffect, useState } from "react";
import { SmallDealImgCard } from "../../components/SmallDealImgCard";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { adminApiService } from "../../../utils/api";
import {
  GfImage,
  GfImageDto,
  GfStore,
  GfUnit,
  UpdateGfPlacementDto,
  UpdateGfProductDto,
  UpdateGfPromotionDto,
} from "@swagger/typescript-fetch-goflyer";
import { useParams } from "react-router-dom";
import { ImageSearchModal } from "../../components/ImageSearchModal";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import "./style.css";
import { CustomAutocompleteMultiSelect } from "../../components/CustomAutocomplete";
import { selectShortCutDateRangeFn } from "../../../utils/SelectRangeDates";
import { useLoading } from "../../../contextApi/LoadingContext";
import { setWebsite } from "../../../utils/getShowAt";
import { makeStoreDisplayName } from "../../../utils/dtoUtil/makeStoreDisplayName";
import { useUnits } from "../../../hooks/useUnits";
import { usePromotionTags } from "../../../hooks";
import { useStores } from "../../../hooks/useStores";
import { useUploadOrPickImages } from "../../../hooks/useUploadOrPickImages";
import { getMontrealStores } from "../../../utils/dtoUtil/getMontrealStores";
import { useHandleSaveDeal } from "./handleSaveDeals";
import {
  InputFieldWrapper,
  InputFieldLabel,
  LeftSideWrapper,
  ProductNameCategorySection,
  SecondLanguageSection,
  MuiAutoCompleteWrapper,
  PriceUnitSection,
  DateSection,
  DateButtonWrapper,
  DateButton,
  RightSideWrapper,
  RightTopTitle,
  UploadImageWrapper,
  ImageSection,
  UploadSection,
  ButtonSection,
  Button,
  EmptyImages,
  SingleImageWrapper,
  CancelSingleImageButton,
  SingleImage,
  DragElement,
  DragInputElement,
  DragText,
  DragClick,
  RightCheckBar,
  InheritTextInputField,
  RankWrapper,
  RankInputField,
  SecondLanguageInputField,
  Container,
  SmallImageWrapper,
  CombineWrapper,
  PromotionTagWrapper,
  PriceFieldsWrapper,
} from "./StyledComponents";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { SelectSearchWithAddMui } from "../../components/SelectSearchWithAddMui";
import { disableWheelOnInput } from "../../../utils/disableWheelOnInput";
import { extractEnglishAndChineseV2 } from "../../../utils/utils";

// this component needs refactoring
const CreateDealTab = () => {
  const { state } = useContext(GoFlyerAdminContext);
  const { promotionId } = useParams();
  const { showLoadingScreen } = useLoading();
  const handleSaveDeal = useHandleSaveDeal();
  const { t } = useTranslation();
  const [updateProduct, setUpdateProduct] = useState<UpdateGfProductDto>();
  const [updatePlacement, setUpdatePlacement] =
    useState<UpdateGfPlacementDto>();
  const [updatePromotion, setUpdatePromotion] =
    useState<UpdateGfPromotionDto>();
  const [storeWebsite, setStoreWebsite] = useState<boolean>(false);
  const [goFlyerWebsite, setGoFlyerWebsite] = useState<boolean>(true);
  const { promotionTags, isPromotionTagsOptionLoading } = usePromotionTags();

  // const [storesOptionList, setStoresOptionList] = useState<GfStore[]>();
  const { storesList, isStoreOptionLoading, handleOnStoreSearch } = useStores();
  const [dateButtonSelected, setDateButtonSelected] = useState(0);
  const { unitsList, fetchUnits } = useUnits();
  const [initialPickedImages, setInitialPickedImages] = useState<GfImageDto[]>(
    [],
  );

  const {
    hasMoreGfImage,
    isSearchingImage,
    openSearchImage,
    productImageList,
    isUploadingImage,
    handleOnSearchPressEnter,
    handlePageChangeScroll,
    handleOnImageFileSelect,
    handleOnRemoveImage,
    handleOnImageClick,
    handleOnImageSearchModalClose,
    handleOnImageSearchModalOpen,
  } = useUploadOrPickImages({
    onPickedImageChange: async (images: GfImage[]) => {
      const TextResult = extractEnglishAndChineseV2(
        images[0]?.fileName || images[0]?.alt || "",
      );

      const nameFrench = TextResult.english
        ? await adminApiService.gfMiscellaneousAdminControllerTranslateTextByGoogle(
            {
              text: TextResult.english,
              sourceLang: "en",
              targetLang: "fr",
            },
          )
        : { result: "" };
      setUpdateProduct((prev) => {
        return {
          ...prev,
          name: TextResult?.english,
          nameChinese: TextResult?.chinese || TextResult?.english,
          nameFrench: nameFrench.result,
          gfImages: images,
        };
      });
    },
    initialPickedImages,
  });

  const handleAddNewUnit = async (value?: GfUnit) => {
    if (value?.name) {
      const unitV2 =
        await adminApiService.createOneBaseGfUnitAdminControllerGfUnit({
          name: value.name,
          adminUser: state.gfAdminUser,
        });

      fetchUnits();
      setUpdatePromotion({
        ...updatePromotion,
        unit: unitV2.name,
        unitV2: unitV2,
      });
    }
  };

  /**
   * On the "Create News" page next to the Day Picker, there are three buttons: "Today Only" (first button), "Friday to Sunday" (second button), and "Monday to Thursday" (third button). This function handles the callbacks for these button clicks.
   * @param buttonIndex - The button value representing a specific date range shortcut.
   */
  const handleDateButtonClick = (buttonIndex: number) => {
    const rangeDate = selectShortCutDateRangeFn(new Date(), buttonIndex);
    setDateButtonSelected(buttonIndex);
    if (rangeDate?.length) {
      setUpdatePromotion((prevValue) => ({
        ...prevValue,
        validStartDate: rangeDate[0],
        validEndDate: rangeDate[1],
      }));
    }
  };

  useEffect(() => {
    if (promotionId) {
      const fetchPromotion = async () => {
        if (promotionId) {
          showLoadingScreen(true);
          const promotion =
            await adminApiService.getOneBaseGfPromotionAdminControllerGfPromotion(
              promotionId,
            );
          setUpdatePromotion(promotion);
          setUpdatePlacement(promotion.placement);
          setUpdateProduct(promotion.placement.product);
          setStoreWebsite(setWebsite(promotion.showAt).storeWebsite);
          setGoFlyerWebsite(setWebsite(promotion.showAt).goflyerWebsite);
          setInitialPickedImages(promotion.placement.product.gfImages || []);
          showLoadingScreen(false);
        }
      };
      fetchPromotion();
    }
  }, [promotionId]);
  useEffect(() => {
    //if the logged in user is managing only one store, auto select that store
    if (state.user && state.user.stores && state.user.stores.length === 1) {
      setUpdatePlacement((prev) => ({
        ...prev,
        store: state.user?.stores?.[0],
      }));
    }
  }, []);

  return (
    <Grid container sx={{ mt: 2 }} data-testid="create-deals-create-page">
      <Grid item xs={12} md={12} lg={6}>
        {" "}
        <LeftSideWrapper>
          <CombineWrapper>
            <ProductNameCategorySection>
              <InputFieldWrapper>
                <InputFieldLabel>
                  {t(messages.English_Name())} *
                </InputFieldLabel>
                <TextInputField
                  placeholder={`${t(messages.English_Name())} *`}
                  value={updateProduct?.name}
                  onChange={(e) => {
                    setUpdateProduct((prevValue) => ({
                      ...prevValue,
                      name: e.target.value,
                    }));
                  }}
                  data-testid="first-name-input"
                ></TextInputField>
              </InputFieldWrapper>
              <InputFieldWrapper>
                <InputFieldLabel>{t(messages.Chinese_Name())}</InputFieldLabel>
                <SecondLanguageInputField
                  placeholder={`${t(messages.Chinese_Name())}`}
                  value={updateProduct?.nameChinese}
                  onChange={(e) => {
                    setUpdateProduct((prevValue) => ({
                      ...prevValue,
                      nameChinese: e.target.value,
                    }));
                  }}
                  data-testid="second-name-input"
                ></SecondLanguageInputField>
              </InputFieldWrapper>

              {updatePlacement?.store &&
                getMontrealStores([updatePlacement.store]).length > 0 && (
                  <SecondLanguageInputField
                    placeholder={`${t(messages.French())}`}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setUpdateProduct((prevValue) => ({
                        ...prevValue,
                        nameFrench: event.target.value,
                      }));
                    }}
                    value={updateProduct?.nameFrench}
                    data-testid="create-flyer-item-modal-second-name-input"
                  ></SecondLanguageInputField>
                )}
            </ProductNameCategorySection>
            <SecondLanguageSection>
              <RankWrapper>
                <InputFieldLabel>{t(messages.Rank())}</InputFieldLabel>
                <RankInputField
                  placeholder={`${t(messages.Rank())}`}
                  value={updatePromotion?.rank}
                  onChange={(e) => {
                    //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) need to check this is a number
                    setUpdatePromotion((prevValue) => ({
                      ...prevValue,
                      rank: parseInt(e.target.value),
                    }));
                  }}
                  type="number"
                  onWheel={disableWheelOnInput}
                  data-testid="rank-input"
                ></RankInputField>
              </RankWrapper>
              <PromotionTagWrapper>
                <CustomAutocompleteMultiSelect
                  title={`${t(messages.Promotion_Tag())}`}
                  optionsList={promotionTags?.map((tag) => ({
                    value: tag,
                    label: tag.name,
                  }))}
                  isLoading={isPromotionTagsOptionLoading}
                  selectedValues={updatePromotion?.promotionTag?.map((tag) => {
                    return {
                      value: tag,
                      label: tag.name,
                    };
                  })}
                  multiSelect={true}
                  handleOnChange={(value) => {
                    setUpdatePromotion((prevValue) => ({
                      ...prevValue,
                      promotionTag: value,
                    }));
                  }}
                  WrapperCss={`
                  width: 10rem;
                  `}
                  inputCss={`
                  width: 10rem;
                  height: 3.5rem;
                  padding: 0;
                  padding-left: 0.8rem;
                  overflow-x:hidden
                  `}
                  inputTextCss={`
                  width: 10rem;
                  max-width: 10rem;
                  min-width: 10rem;
                  padding: 0;
                  padding-left: 0.5rem;
                  `}
                  selectListCss={`
                  max-width: 10rem;
                  min-width: 10rem;
                  `}
                  dataTestId="promotionTag-select"
                />
              </PromotionTagWrapper>
            </SecondLanguageSection>
          </CombineWrapper>
          <PriceUnitSection>
            <PriceFieldsWrapper>
              <InputFieldLabel>{`${t(
                messages.Sale_Price(),
              )} *`}</InputFieldLabel>
              <InheritTextInputField
                placeholder={`${t(messages.Sale_Price())} *`}
                type="number"
                onWheel={disableWheelOnInput}
                value={updatePromotion?.price}
                onChange={(e) => {
                  setUpdatePromotion((prevValue) => ({
                    ...prevValue,
                    price: parseFloat(e.target.value),
                  }));
                }}
                data-testid="sale-price-input"
              ></InheritTextInputField>
            </PriceFieldsWrapper>
            <PriceFieldsWrapper>
              <InputFieldLabel>{`${t(messages.Reg_Price())}`}</InputFieldLabel>
              <InheritTextInputField
                placeholder={`${t(messages.Regular_Price())}`}
                type="number"
                onWheel={disableWheelOnInput}
                value={updatePlacement?.price}
                onChange={(e) => {
                  setUpdatePlacement({
                    ...updatePlacement,
                    price: parseFloat(e.target.value),
                  });
                }}
                data-testid="regular-price-input"
              ></InheritTextInputField>
            </PriceFieldsWrapper>
            <PriceFieldsWrapper>
              <InputFieldLabel>{`${t(messages.Quantity())}`}</InputFieldLabel>
              <InheritTextInputField
                placeholder={`${t(messages.Quantity())}`}
                type="number"
                onWheel={disableWheelOnInput}
                value={updatePromotion?.quantity}
                onChange={(e) => {
                  setUpdatePromotion({
                    ...updatePromotion,
                    quantity: parseFloat(e.target.value),
                  });
                }}
                data-testid="regular-price-input"
              ></InheritTextInputField>
            </PriceFieldsWrapper>

            <SelectSearchWithAddMui<GfUnit>
              title={`${t(messages.Unit())}  *`}
              selectOptions={unitsList}
              selectedValue={
                updatePromotion?.unitV2 ||
                unitsList?.find((val) => val.name === updatePromotion?.unit)
              }
              onSelect={(value) => {
                setUpdatePromotion({
                  ...updatePromotion,
                  unit: value.name,
                  unitV2: value,
                });
              }}
              onAddNew={handleAddNewUnit}
              wrapperStyle={{
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginLeft: "10px",
                rowGap: "10px",
              }}
              dataTestId="unit-select"
            ></SelectSearchWithAddMui>
          </PriceUnitSection>
          <MuiAutoCompleteWrapper>
            <CustomAutocompleteMultiSelect
              title={`${t(messages.Stores())} *`}
              optionsList={storesList?.map((store) => ({
                value: store,
                label: makeStoreDisplayName(store),
              }))}
              isLoading={isStoreOptionLoading}
              selectedValues={
                //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) this is a temp solution
                updatePlacement && updatePlacement.store
                  ? [updatePlacement?.store].map((store) => {
                      return {
                        value: store,
                        label: makeStoreDisplayName(store),
                      };
                    })
                  : []
              } //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) a deal belong to one store
              multiSelect={false}
              handleOnChange={(stores: GfStore[] | undefined) => {
                if (stores) {
                  if (stores && getMontrealStores(stores).length === 0) {
                    /**
                     * requirement here is that if we select a French store, we need to show the french input and add a french name. when edit the flyer item and remove that French store, we should remove that language.
                     */
                    setUpdateProduct((prevValue) => ({
                      ...prevValue,
                      nameFrench: "", //TODO temp solution, maybe there is a better way
                    }));
                  }
                  setUpdatePlacement({ ...updatePlacement, store: stores[0] });
                }
              }}
              handleOnSearch={handleOnStoreSearch}
              WrapperCss={`
              margin-left:10px;
              `}
              dataTestId="store-select"
            />
          </MuiAutoCompleteWrapper>
          <DateSection>
            <DateButtonWrapper>
              <DateButton
                onClick={() => {
                  handleDateButtonClick(1);
                }}
                isSelected={dateButtonSelected === 1}
                data-testid="date-today-button"
              >
                {t(messages.Today_Only())}
              </DateButton>
              <DateButton
                isSelected={dateButtonSelected === 2}
                onClick={() => {
                  handleDateButtonClick(2);
                }}
                data-testid="date-fri-sun-button"
              >
                {t(messages.Fri_Sun())}
              </DateButton>
              <DateButton
                isSelected={dateButtonSelected === 3}
                onClick={() => {
                  handleDateButtonClick(3);
                }}
                data-testid="date-mon-thur-button"
              >
                {t(messages.Mon_Thur())}
              </DateButton>
              <DateButton
                isSelected={dateButtonSelected === 4}
                onClick={() => {
                  handleDateButtonClick(4);
                }}
                data-testid="date-thur-fri-button"
              >
                {t(messages.Thur_Fri())}
              </DateButton>
            </DateButtonWrapper>
            <DateRange
              ranges={[
                {
                  startDate:
                    updatePromotion && updatePromotion.validStartDate
                      ? new Date(updatePromotion.validStartDate) //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) not sure why we need to do new Date again since validStartDate is already Date data type, will come back later
                      : new Date(),
                  endDate:
                    updatePromotion && updatePromotion?.validEndDate
                      ? new Date(updatePromotion.validEndDate)
                      : new Date(),
                  key: "selection",
                },
              ]}
              months={2}
              moveRangeOnFirstSelection={false}
              showPreview={true}
              rangeColors={["#EF8200"]}
              displayMode="dateRange"
              color="#EF8200"
              direction="horizontal"
              showDateDisplay={false}
              onChange={(item) => {
                setUpdatePromotion((prevValue) => ({
                  ...prevValue,
                  validStartDate: item.selection.startDate,
                  validEndDate: item.selection.endDate,
                }));
              }}
            />
          </DateSection>
        </LeftSideWrapper>
      </Grid>
      <Grid item xs={12} md={12} lg={6}>
        <RightSideWrapper>
          <RightTopTitle>{`${t(messages.Product_Images())} *`}</RightTopTitle>
          <UploadImageWrapper>
            <ImageSection data-testid="create-deals-image-section">
              {updateProduct?.gfImages?.length === 1 && (
                <SingleImageWrapper>
                  <SingleImage
                    src={updateProduct?.gfImages[0]?.src}
                  ></SingleImage>
                  <CancelSingleImageButton
                    onClick={() => {
                      //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) not sure why we need to check again, I checked above already
                      if (updateProduct.gfImages) {
                        handleOnRemoveImage(updateProduct.gfImages[0].id);
                      }
                    }}
                  >
                    <CancelIcon
                      style={{ fontSize: 30 }}
                      data-testid="create-deals-image-cancel"
                    />
                  </CancelSingleImageButton>
                </SingleImageWrapper>
              )}
              {(!updateProduct?.gfImages ||
                updateProduct?.gfImages.length === 0) && (
                <EmptyImages>{t(messages.No_images_added_yet())}</EmptyImages>
              )}
              {
                <>
                  {(updateProduct?.gfImages?.length || 0) > 1 && (
                    <Container>
                      {updateProduct?.gfImages?.map(
                        (gfImage: GfImage, index: number) => {
                          return (
                            <SmallImageWrapper
                              key={index}
                              data-testid="createdealtab-test-id"
                            >
                              <SmallDealImgCard
                                imageSrc={gfImage.src}
                                cancelButtonClick={() => {
                                  handleOnRemoveImage(gfImage.id);
                                }}
                              />
                              <CancelSingleImageButton
                                onClick={() => {
                                  handleOnRemoveImage(gfImage.id);
                                }}
                              ></CancelSingleImageButton>
                            </SmallImageWrapper>
                          );
                        },
                      )}
                    </Container>
                  )}
                </>
              }
            </ImageSection>
            <UploadSection>
              <DragElement>
                {isUploadingImage && (
                  <CircularProgress
                    data-testid="local-image-loader"
                    sx={{ color: "#ff813a" }}
                    size={150}
                  />
                )}
                {!isUploadingImage && (
                  <ImageOutlinedIcon
                    style={{ fontSize: 160, marginTop: 20 }}
                  ></ImageOutlinedIcon>
                )}
                <DragText>{t(messages.Drag_your_image_here())}</DragText>
                <DragClick
                  onClick={handleOnImageSearchModalOpen}
                  data-testid="click-browse-button"
                >
                  {t(messages.or_click_to_browse())}
                </DragClick>
                <DragInputElement
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleOnImageFileSelect(e, "productImages")}
                  data-testid="image-local-upload"
                />
              </DragElement>
            </UploadSection>
          </UploadImageWrapper>
          <ButtonSection>
            <Button
              onClick={() => {
                handleSaveDeal(
                  storeWebsite,
                  goFlyerWebsite,
                  updateProduct,
                  updatePlacement,
                  updatePromotion,
                );
              }}
              data-testid="submit-button"
            >
              {updatePromotion?.id ? t(messages.Update()) : t(messages.Done())}
            </Button>
            <Button>{`${t(messages.Sync_Update())}`}</Button>

            {/* <Button>{`${t(messages.Save_Product())}`}</Button> */}
          </ButtonSection>
          <RightCheckBar>
            <CheckBoxMui
              title={t(messages.Store_website_APP()) as string}
              CheckboxStyle={{
                color: "white",
              }}
              FormControlStyle={{
                "& .MuiFormControlLabel-label": {
                  fontSize: {
                    sm: "12px",
                    md: "22px",
                  },
                },
              }}
              value={storeWebsite}
              onChange={(
                // eslint-disable-next-line no-unused-vars
                event: React.ChangeEvent<HTMLInputElement>,
                // eslint-disable-next-line no-unused-vars
                checked: boolean,
              ) => {
                setStoreWebsite(checked);
              }}
              dataTestId="store-website-check"
            />
            <CheckBoxMui
              title={t(messages.Goflyer_website_APP()) as string}
              CheckboxStyle={{
                color: "white",
              }}
              FormControlStyle={{
                "& .MuiFormControlLabel-label": {
                  fontSize: {
                    sm: "12px",
                    md: "22px",
                  },
                },
              }}
              value={goFlyerWebsite}
              onChange={(
                // eslint-disable-next-line no-unused-vars
                event: React.ChangeEvent<HTMLInputElement>,
                // eslint-disable-next-line no-unused-vars
                checked: boolean,
              ) => {
                setGoFlyerWebsite(checked);
              }}
              dataTestId="goflyer-website-check"
            />
          </RightCheckBar>
        </RightSideWrapper>
      </Grid>
      <ImageSearchModal
        handleClose={handleOnImageSearchModalClose}
        open={openSearchImage}
        onSearch={handleOnSearchPressEnter}
        itemsList={productImageList}
        onItemClick={handleOnImageClick}
        hasMore={hasMoreGfImage}
        getMoreGfImage={handlePageChangeScroll}
        isSearchingImage={isSearchingImage}
      />
    </Grid>
  );
};

export default CreateDealTab;
